import { wrapHeaders } from "~/utils/fetch";

export const fetchAdapter = (url: string, init: RequestInit) => {
  return fetch(url, wrapHeaders(init));
};
